import React from 'react';
import { Youtube } from 'lucide-react';

const TutorialButton = () => {
  return (
    <a
      href="https://www.youtube.com/@PropertyARV"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="tutorial-button"
      className="flex items-center gap-1.5 px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded-full text-sm font-medium transition-colors"
    >
      <Youtube className="h-5 w-5" />
      <span className="hidden sm:inline">Tutorials</span>
    </a>
  );
};

export default TutorialButton;
